(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["as-services-cards"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const carouselContainer = document.getElementById('carouselContainer');
    const prevBtn = document.getElementById('prevBtn');
    const nextBtn = document.getElementById('nextBtn');

    if (!carouselContainer || !prevBtn || !nextBtn) return;

    function scrollCarousel(direction) {
      const cardWidth = carouselContainer.querySelector('.as-service-card')?.offsetWidth || 220;
      const gap = 16;
      const scrollAmount = (cardWidth + gap) * 1.5;

      carouselContainer.scrollBy({
        left: direction === 'next' ? scrollAmount : -scrollAmount,
        behavior: 'smooth'
      });
    }

    function updateCarouselButtons() {
      const maxScroll = carouselContainer.scrollWidth - carouselContainer.clientWidth;
      prevBtn.disabled = carouselContainer.scrollLeft <= 0;
      nextBtn.disabled = carouselContainer.scrollLeft >= maxScroll - 10;
    }

    prevBtn.addEventListener('click', () => scrollCarousel('prev'));
    nextBtn.addEventListener('click', () => scrollCarousel('next'));
    carouselContainer.addEventListener('scroll', updateCarouselButtons);

    updateCarouselButtons();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marketing-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const carouselContainer = document.getElementById('carouselContainer');
    const prevBtn = document.getElementById('prevBtn');
    const nextBtn = document.getElementById('nextBtn');

    if (!carouselContainer || !prevBtn || !nextBtn) return;

    function scrollCarousel(direction) {
      const cardWidth = carouselContainer.querySelector('.as-service-card')?.offsetWidth || 220;
      const gap = 16;
      const scrollAmount = (cardWidth + gap) * 1.5;

      carouselContainer.scrollBy({
        left: direction === 'next' ? scrollAmount : -scrollAmount,
        behavior: 'smooth'
      });
    }

    function updateCarouselButtons() {
      const maxScroll = carouselContainer.scrollWidth - carouselContainer.clientWidth;
      prevBtn.disabled = carouselContainer.scrollLeft <= 0;
      nextBtn.disabled = carouselContainer.scrollLeft >= maxScroll - 10;
    }

    prevBtn.addEventListener('click', () => scrollCarousel('prev'));
    nextBtn.addEventListener('click', () => scrollCarousel('next'));
    carouselContainer.addEventListener('scroll', updateCarouselButtons);

    updateCarouselButtons();
  });

  } catch(e) { console.error(e); }
})();
})();
